/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleFacebook_item = {
    readonly title: string | null;
    readonly " $refType": "PdpSharedIconBubbleFacebook_item";
};
export type PdpSharedIconBubbleFacebook_item$data = PdpSharedIconBubbleFacebook_item;
export type PdpSharedIconBubbleFacebook_item$key = {
    readonly " $data"?: PdpSharedIconBubbleFacebook_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleFacebook_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedIconBubbleFacebook_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '1ee214ae8acee7f3ada289e7d82a9d20';
export default node;
